import { render, staticRenderFns } from "./SuggestedEquipment.vue?vue&type=template&id=2ae69b06&scoped=true"
import script from "./SuggestedEquipment.vue?vue&type=script&lang=js"
export * from "./SuggestedEquipment.vue?vue&type=script&lang=js"
import style0 from "./SuggestedEquipment.vue?vue&type=style&index=0&id=2ae69b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae69b06",
  null
  
)

export default component.exports